import { useEffect, useState } from "react";
import useAccelContext from "../../contexts/AccelContext";
import { Accel } from "../../api/accel";
import { AccountContextValues } from "../../contexts/AccountsContext/AccountsContext";
import useSWR from "swr";

export const useAccounts = (): AccountContextValues => {
  const { auth, companyId, apiUrl } = useAccelContext();
  const [loadingStatus, setLoadingStatus] = useState("initial");

  const {
    data: responseData,
    error: responseError,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(
    `bank-accounts-${companyId}`,
    Accel.getAccounts(apiUrl, auth.access_token, {
      params: { companyId },
    })
  );

  useEffect(() => {
    if (isLoading && loadingStatus === "initial") {
      setLoadingStatus("loading");
      return;
    }

    if (!isLoading && loadingStatus === "loading") {
      setLoadingStatus("complete");
      return;
    }
  }, [isLoading]);

  const refetch = () => {
    mutate();
  };
  return {
    accounts: responseData?.plaidAccounts ?? [], // Updated to plaidAccounts
    total: responseData?.totalBalance ?? 0,
    loadingStatus,
    isValidating,
    refetch,
    error: responseError,
  };
};
export default useAccounts;
